// Import Packages
import React, { useState, useEffect } from 'react';

// Import Material UI
import { IconButton, OutlinedInput } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import Grid from "@material-ui/core/Grid";
import CloseIcon from "@material-ui/icons/Close";
import { Close } from '@material-ui/icons';

// Import Recoil
import { atomSearchValue } from '../../recoil-store/recoil-state';
import { useRecoilState } from 'recoil';

// Import CSS
import './styles.css'

/*
*  @Description : It navigates through the sent data. Searches the text entered from the keyboard in the sent keys.
*  @author  : Kerem Karadeniz
*  @Params :{data,searchKeyData}
*  @return : newData
* */


function Search(props) {
    const [value, setValue] = useState("");
    const [customClasses, setCustomClasses] = useState("");
    const [searchValue, setSearchValue] = useRecoilState(atomSearchValue);
    // const { setSearchValue } = props;
    useEffect(() => {
        // setValue("");
        // setSearchValue("")
        if (props.customClasses && props.customClasses.length) {
            const classes = props.customClasses.join(' ');
            setCustomClasses(classes);
        }
    }, [props.data])
    useEffect(() => {
        // setValue(searchValue)
        setSearchValue("")
    }, [])

    function handleSearch(event) {
        let searchText = event.target.value;
        setValue(event.target.value);
        if (setSearchValue && !props.setSearchData) {
            setSearchValue(event.target.value)
            return
        }
        if (props.data) {
            let searchData = props.data.map(row =>
                props.searchKey.map(key =>
                    row[key] !== null && row[key]?.toString().toLowerCase().indexOf(searchText.toLowerCase()) !== -1))
            let newSearchData = [];
            let groupedByAppName = {};
            for (let i = 0; i < searchData.length; i++) {
                if (searchData[i].indexOf(true) !== -1) {
                    if (!props.grandArray) {
                        newSearchData.push(props.data[i])
                    }
                    else {
                        const appName = props.data[i].application_name;
                        if (!groupedByAppName[appName]) {
                            groupedByAppName[appName] = [];
                        }
                        groupedByAppName[appName].push(props.data[i]);
                    }
                }
            }
            if (props.grandArray) {
                let resultArray = Object.values(groupedByAppName);
                props.setSearchData(resultArray)
                return
            }
            props.setSearchData(newSearchData)
            if (searchText.length < 1) {
                props.setSearchData(props.data)
            }
        }
    }

    const handleClear = () => {
        setValue("");
        setSearchValue("")
        handleSearch({ target: { value: "" } });
    };

    return (
        <div className={`searchbar-bg ${customClasses}`}>
            <Grid container spacing={props.spacing} style={{ marginTop: 10 }} className={props.outClassName}>
                {props.label}
                <Grid item xs={props.xs} sm={props.sm} md={props.md} lg={props.lg} xl={props.xl}>
                    <OutlinedInput
                        id="outlined-adornment-amount"
                        className="searchbar-input"
                        value={value}
                        autoFocus={true}
                        onFocus={(event) => {
                            event.target.setAttribute('autocomplete', 'off');
                        }}
                        placeholder="Search..."
                        onChange={(event) => handleSearch(event)}
                        startAdornment={<InputAdornment position="start"><SearchIcon
                            className="searchbar-icon" /></InputAdornment>}
                        endAdornment={
                            value && (
                                <InputAdornment position="end">
                                    <Close className="autom-group-close-button logs-close-icon" onClick={handleClear} style={{ fontSize: "1rem" }} />
                                </InputAdornment>
                            )
                        }

                    />
                </Grid>
                {props.children}
            </Grid>
        </div>
    )
        ;
}

export default Search;
